import { Directive, HostListener } from '@angular/core';
import { Message } from 'primeng/components/common/api';

@Directive({
    selector: '[appVerificarCapsUp]'

})
export class VerificarCapsUpDirective {

    msgs: Message[] = [];


    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        (event.key.toLowerCase().indexOf('capslock') !== -1) ? this.show() : this.hide()
    }

    show() {
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Atenção', detail: 'CapsLock Está Ativo' });

    }

    hide() {
        this.msgs = [];
    }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/directives/verificar-caps-up.directive.ts